module.exports = __webpack_public_path__ + "h5/img/kefu.a64b8148.png";